module.exports = __webpack_public_path__ + "img/car.3532d3fc.png";